import { render, staticRenderFns } from "./PalletPageStats.vue?vue&type=template&id=7e06f28a&scoped=true"
import script from "./PalletPageStats.vue?vue&type=script&lang=js"
export * from "./PalletPageStats.vue?vue&type=script&lang=js"
import style0 from "./PalletPageStats.vue?vue&type=style&index=0&id=7e06f28a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e06f28a",
  null
  
)

export default component.exports